import { result, set } from 'libraries/lodash'

export const parseJson = function (json) {
  return eval("(" + json + ")"); // eslint-disable-line
}

export const sortKeys = function (obj) {
  const keys = Object.keys(obj)
    .sort()
    .reverse()
  return Object.assign({}, ...keys.map(k => ({ [k]: obj[k] })))
}

export const touch = function (obj, path, value) {
  if (!result(obj, path)) {
    set(obj, path, value)
  }
  return result(obj, path)
}

export const deepPush = function (obj, path, value) {
  touch(obj, path, [])
  const target = result(obj, path)
  if (target.indexOf(value) === -1) {
    target.push(value)
  } else if (console && console.error) {
    console.error(`Duplicate value "${value}" in ${path.join('.')}`)
  }
}

export const addCommas = x => {
  const [n, m = ''] = (x || 0).toString().split(/\./)
  const nf = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return m ? `${nf}.${m}` : nf
}

export const groupBy = (obj, groupingKey) => {
  const keys = Object.keys(obj)

  const grouped = keys.reduce((acc, curr) => {
    const node = obj[curr]
    const key = node[groupingKey]
    const currentGroup = acc[key] || {}

    return {
      ...acc,
      [key]: {
        ...currentGroup,
        [node.id]: node
      }
    }
  }, {})

  return grouped
}
